import { SVGProps } from 'react';

export default (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="348"
    height="46"
    viewBox="0 0 348 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="348" height="46" rx="2" fill="#F6F6F6" />
    <path
      d="M23.0446 23C23.0446 26.8634 19.9032 30 16.0223 30C12.1414 30 9 26.8634 9 23C9 19.1366 12.1414 16 16.0223 16C19.9032 16 23.0446 19.1366 23.0446 23Z"
      fill="#BBBBBB"
      stroke="#BBBBBB"
      strokeWidth="2"
    />
    <ellipse cx="332.022" cy="23" rx="8.02228" ry="8" fill="#BBBBBB" />
    <mask id="path-4-inside-1_1024_100472" fill="white">
      <rect x="166" y="15" width="16.0446" height="16" rx="1" />
    </mask>
    <rect
      x="166"
      y="15"
      width="16.0446"
      height="16"
      rx="1"
      fill="white"
      stroke="#0696D7"
      strokeWidth="4"
      mask="url(#path-4-inside-1_1024_100472)"
    />
    <path
      d="M161 23L156 20.1133L156 25.8868L161 23ZM27 23.5L156.5 23.5L156.5 22.5L27 22.5L27 23.5Z"
      fill="#999999"
    />
    <path
      d="M320 23L315 20.1133L315 25.8868L320 23ZM186 23.5L315.5 23.5L315.5 22.5L186 22.5L186 23.5Z"
      fill="#999999"
    />
  </svg>
);
